module.exports = __webpack_public_path__ + "static/raiox_2-1388542ab1b52cdcc722c4b6bb655be6.jpg";